import { Pipe, PipeTransform } from "@angular/core";

import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
    name: "arrayToString",
    standalone: false
})

export class ArrayToStringPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  transform(input: string[], sep = ", ", html = false, propName: string): any {
    let output;
    if (propName) {
      output = input.map((item) => (item[propName])).join(sep);
    } else {
      output = input.join(sep);
    }
    if (html) {
      return this.sanitizer.bypassSecurityTrustHtml(output);
    } else {
      return output;
    }
  }
}